import { applyMiddleware, createStore, type Action, type Middleware, type StoreEnhancer } from 'redux';
import { enableBatching } from 'redux-batched-actions';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware, type Epic } from 'redux-observable';
import { rootEpic, rootReducer } from './root';

const epicMiddleware = createEpicMiddleware();

const configureStore = () => {
  const middlewares: Middleware[] = [epicMiddleware];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const enhancers: StoreEnhancer[] = [middlewareEnhancer];
  const composedEnhancers = composeWithDevTools(...enhancers);

  const store = createStore(enableBatching(rootReducer()), undefined, composedEnhancers);

  epicMiddleware.run(rootEpic as Epic<Action, Action, void>);

  return store;
};

export default configureStore;
